import { supabase, sendMessage } from './supabase'

// ── Tijdelijke acties met externe winkeliers ─────────────────────────────
// Elk kwartaal een andere actie ("Support Your Locals"). Een volgende actie
// vergt alleen een nieuw object hieronder, in de lijst PROMOTIES, een nieuw
// logo in /public en dezelfde actie in de webhook
// (supabase/functions/sportivity-visit-webhook/index.ts). De schermen
// (StempelkaartTab, AdminStempelkaartTab) hoeven niet aangepast te worden.
//
// De omschakeling gaat vanzelf op de startdatum van de volgende actie; de
// vorige actie verdwijnt automatisch na haar einddatum (eind is exclusief).

export const ALEXANDERHOEVE_PROMO = {
  key: 'alexanderhoeve_q4_2026',
  naam: 'Alexanderhoeve',
  naamInZin: 'de Alexanderhoeve',
  kwartaalLabel: '4de kwartaal 2026',
  // Q4 2026: 1 oktober t/m 31 december.
  start: new Date('2026-10-01T00:00:00'),
  eind: new Date('2027-01-01T00:00:00'),
  logoSrc: '/Alexanderhoeve.jpg',
  vakjeLabel: 'Attentie',
  promoTekst: 'maak je fasekaart deze periode vol en ontvang een attentie als beloning voor je doorzettingsvermogen en het trainen van je spieren 💪🏻.',
  berichtExtra: '',
}

export const UNIEK_PROMO = {
  key: 'uniek_q1_2027',
  naam: 'Uniek',
  naamInZin: 'Uniek',
  kwartaalLabel: '1ste kwartaal 2027',
  // Q1 2027: 1 januari t/m 31 maart.
  start: new Date('2027-01-01T00:00:00'),
  eind: new Date('2027-04-01T00:00:00'),
  logoSrc: '/Uniek.jpg',
  vakjeLabel: 'Attentie',
  promoTekst: 'maak je fasekaart deze periode vol en ontvang een attentie van Uniek in Baarn, waar je kunt ontbijten, lunchen of koffiedrinken, als beloning voor je doorzettingsvermogen ☕.',
  berichtExtra: ' Bij Uniek in Baarn kun je ontbijten, lunchen of koffiedrinken.',
}

// Chronologisch. Nieuwe acties hier onderaan toevoegen.
export const PROMOTIES = [ALEXANDERHOEVE_PROMO, UNIEK_PROMO]

export function promoIsActief(promo, nu = new Date()) {
  return nu >= promo.start && nu < promo.eind
}

// De actie die nu loopt, of null.
export function actievePromo(nu = new Date()) {
  return PROMOTIES.find(p => promoIsActief(p, nu)) ?? null
}

// Het felicitatiebericht bij een volle fasekaart. Moet gelijk blijven aan de
// tekst in de webhook (sportivity-visit-webhook).
export function promoBericht(promo, naam) {
  const voornaam = (naam || '').trim().split(' ')[0] || 'daar'
  return `Gefeliciteerd, ${voornaam}! Je fasekaart is vol. Je krijgt een leuke attentie van ${promo.naamInZin} bij je fasewissel.${promo.berichtExtra}`
}

// Haalt op of dit lid deze actie al heeft ontvangen (en voor welke fase), of null.
export async function haalPromoOntvangst(memberId, promoKey) {
  const { data, error } = await supabase
    .from('promo_ontvangsten')
    .select('*')
    .eq('member_id', memberId)
    .eq('promo_key', promoKey)
    .maybeSingle()
  if (error) throw error
  return data
}

// Alle ontvangen acties van dit lid (over alle kwartalen heen).
export async function haalPromoOntvangsten(memberId) {
  const { data, error } = await supabase
    .from('promo_ontvangsten')
    .select('*')
    .eq('member_id', memberId)
    .in('promo_key', PROMOTIES.map(p => p.key))
  if (error) throw error
  return data ?? []
}

// Welk logo hoort op het laatste vakje van de (volle) fasekaart in deze fase?
// Een lid dat zijn kaart vol heeft gekregen in een actieperiode krijgt het logo
// van de actie die NU loopt. Op de wisseldatum (bv. 1 januari) schakelt het
// logo op een nog volle kaart dus vanzelf om naar de nieuwe actie; na de laatste
// actieperiode verdwijnt het logo.
export function promoVoorKaart(ontvangsten, fase, nu = new Date()) {
  const heeftOntvangstInFase = (ontvangsten ?? []).some(o => o.fase === fase)
  return heeftOntvangstInFase ? actievePromo(nu) : null
}

// Wordt aangeroepen op het moment dat een fasekaart vol raakt (20/20).
// Registreert de ontvangst (max 1x per lid per actie) en stuurt het
// automatische berichtje. Doet niets als er geen actie loopt, of als
// dit lid 'm al eerder heeft ontvangen.
export async function verwerkFasekaartVolPromo({ memberId, naam, fase, promo = actievePromo() }) {
  if (!promo || !promoIsActief(promo)) return null

  const bestaand = await haalPromoOntvangst(memberId, promo.key)
  if (bestaand) return bestaand

  const { data, error } = await supabase
    .from('promo_ontvangsten')
    .insert({ member_id: memberId, promo_key: promo.key, fase })
    .select()
    .single()
  if (error) {
    // Iemand anders kan tegelijk hetzelfde bezoek verwerken — bij een dubbele
    // insert (unique-constraint) is dit lid net al verwerkt, dus gewoon stoppen.
    if (error.code === '23505') return await haalPromoOntvangst(memberId, promo.key)
    throw error
  }

  await sendMessage({
    memberId,
    fromAdmin: true,
    text: promoBericht(promo, naam),
  })

  return data
}
